export default{
    c1:"暂无任务，请使用点券支付",
    c2:"返回",
}